export const logOnboarding = (data, cancelToken) => (
  (dispatch, getState, api) => api({
    method: 'post',
    apiPath: 'onboarding',
    data,
    cancelToken
  })
)
